import type { BasicProfileForLookup } from '@/lib/profile-lookup';
import { createProfileLookup } from '@/lib/profile-lookup';
import type { Tweet } from '@/types/tweet';

function collectAuthors(tweet: Tweet | undefined | null, target: BasicProfileForLookup[]): void {
  if (!tweet) {
    return;
  }

  if (tweet.author) {
    target.push({
      username: tweet.author.username,
      name: tweet.author.name ?? tweet.author.username,
      profileImageUrl: tweet.author.profileImageUrl ?? null,
    });
  }

  if (tweet.quotedTweet) {
    collectAuthors(tweet.quotedTweet, target);
  }

  if (tweet.retweetedTweet) {
    collectAuthors(tweet.retweetedTweet, target);
  }
}

export function buildMentionProfileLookup(
  tweet: Tweet | undefined | null
): Map<string, { username: string; name?: string | null; profileImageUrl?: string | null }> | null {
  if (!tweet) {
    return null;
  }

  const sources: BasicProfileForLookup[] = [];

  collectAuthors(tweet, sources);

  if (Array.isArray(tweet.entities?.mentions)) {
    for (const mention of tweet.entities.mentions) {
      if (!mention?.username) {
        continue;
      }
      sources.push({
        username: mention.username,
        name: mention.name ?? mention.username ?? null,
        profileImageUrl: mention.profileImageUrl ?? null,
      });
    }
  }

  const lookup = createProfileLookup(sources);
  return lookup.size > 0 ? lookup : null;
}
